import { JSX } from 'react';
import { Option } from '../../types/option';
import { useQuery } from '@tanstack/react-query';
import FormSelect, { FormSelectProps } from './formSelect';

interface AsyncFormSelectProps extends Omit<FormSelectProps, 'options'> {
  /**
   * API endpoint to load the options from.
   */
  optionsEndpoint: string;
}

/**
 * A select component that loads its options from an API endpoint.
 */
const AsyncFormSelect = ({ optionsEndpoint, ...props }: AsyncFormSelectProps): JSX.Element => {
  const { data: options } = useQuery<Option[]>({
    queryKey: [optionsEndpoint],
  });

  // Remove the "Unknown" option from the list of options.
  const optionsToRender = options?.filter(({ id }) => id !== 0);

  return <FormSelect {...props} options={optionsToRender} />;
};

export default AsyncFormSelect;
